import SvgArrowRight from '@sats-group/icons/24/arrow-right';
import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import Text from '@sats-group/ui-lib/react/text';
import TextInput from '@sats-group/ui-lib/react/text-input';
import React, { useRef } from 'react';
import { useAddMember } from '~/source/client/use-add-member';
import { Dialog } from '~/source/ui/dialog/dialog';
import type { EnrollOption as Props } from './enroll-option.types';

export const EnrollOption: React.FC<Props> = ({
  action,
  copy,
  data,
  id,
  inputs,
  onCompletion = () => {},
  testId,
}) => {
  const dialog = useRef<HTMLDialogElement>(null);
  const form = useRef<HTMLFormElement>(null);

  const [execute, isSubmitting] = useAddMember(action, {
    failure: copy.failure,
    success: copy.success,
  });

  const handleCompletion = () => {
    if (dialog.current) {
      dialog.current.hidePopover();
    }

    if (form.current) {
      form.current.reset();
    }

    onCompletion();
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async event => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    if (!form.current) {
      return;
    }

    await execute(new FormData(form.current), handleCompletion);
  };

  return (
    <div className="enroll-option">
      <button
        className="enroll-option__trigger"
        data-testid={testId}
        popoverTarget={id}
        popoverTargetAction="show"
      >
        <div className="enroll-option__trigger-text">
          <Text theme={Text.themes.emphasis}>{copy.trigger.primary}</Text>
          <Text size={Text.sizes.small}>{copy.trigger.secondary}</Text>
        </div>
        <SvgArrowRight />
      </button>
      <Dialog close={copy.close} id={id} ref={dialog} title={copy.title}>
        <Text>{copy.description}</Text>
        <form
          action={action}
          className="enroll-option__form"
          method="post"
          onSubmit={handleSubmit}
          ref={form}
        >
          {data.map(entry => (
            <HiddenInput {...entry} key={entry.name} />
          ))}
          {inputs.map(entry => (
            <TextInput {...entry} key={entry.name} required />
          ))}
          <Button
            disabled={isSubmitting}
            spinning={isSubmitting}
            testId="enroll-submit"
            text={copy.submit}
            type="submit"
            variant={Button.variants.complete}
            wide
          />
        </form>
      </Dialog>
    </div>
  );
};
